<template>
    <form @submit.prevent="handleSubmit" method="POST" :action="action" v-loading="state==='loading'">
        <div v-if="state==='error' && !noAlert || state==='failed'" class="alert alert-danger">
            {{ message }}
        </div>
        <slot v-if="state==='success'" name="success" :message="message">
            <div class="alert alert-success">
                {{ message || successMessage }}
            </div>
        </slot>
        <div v-show="!(state==='success' && replaceWithMessage)">
            <slot></slot>
        </div>
    </form>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'AcaForm',
        props: {
            action: {
                type: String,
                required: true
            },
            replaceWithMessage: Boolean,
            noAlert: Boolean,
            successMessage: {
                type: String,
                default: 'Le formulaire a été envoyé avec succès'
            }
        },
        provide() {
            return {
                form:this
            }
        },
        data() {
            return {
                state: null,
                message: null
            }
        },
        methods: {
            handleFailed() {
                this.state = 'failed';
                this.message = "Impossible d'envoyer le formulaire, veillez réessayer plus tard";
            },
            handleSubmit() {
                this.state="loading";
                this.message=null;
                this.$emit('submitting');
                axios.post(this.action, new FormData(this.$el))
                    .then(response =>{
                        let { data } = response;
                        this.state = 'success';
                        this.$emit('success');
                        this.message = data.message;
                    })
                    .catch(error => {
                        if(error.response.status !== 422) {
                            return this.handleFailed();
                        }
                        try {
                            let { data: { errors } } = error.response;
                            this.state='error';
                            this.message = 'Il y a une ou plusieurs erreurs dans le formulaire';
                            this.$emit('error', errors);
                        } catch(e) {
                            this.handleFailed();
                        }
                    })
            }
        }
    }
</script>

